export interface AuthErrorCopy {
  title: string;
  body: string;
  qrLabel: string;
  linkbookLabel: string;
}

export function getAuthErrorCopy(error: string | null): AuthErrorCopy {
  if (error === 'account_not_linked') {
    return {
      title: 'Finish email verification',
      body: 'This Google account matches an existing email account. Sign in with email first, verify the address if prompted, then try Google again.',
      qrLabel: 'Open CITTAM QR',
      linkbookLabel: 'Sign in to LinkBook',
    };
  }

  return {
    title: 'Google sign-in could not finish',
    body: 'Try signing in again. If the problem continues, use email sign-in instead.',
    qrLabel: 'Open CITTAM QR',
    linkbookLabel: 'Sign in to LinkBook',
  };
}

export function getLinkbookSignInUrl(envValue?: string): string {
  return envValue?.trim() || 'https://linkbook.cittam.com/sign-in?return=/app';
}
